import '../css/CosmosPage.css';
import logo from '../../assets/images/CosmosLogo.png';

import { Button, Carousel, Col, Container, Image, Row } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';


import bannerImg from '../../assets/images/CPR_COSMOS/cosmos_bannerImg.webp'
import floorPlanImg from '../../assets/images/CPR_COSMOS/cosmos-floor-plan-layout.webp';
import allBlocksImg from '../../assets/images/CPR_COSMOS/allBlocks.webp';
import clubhouseImg from '../../assets/images/CPR_COSMOS/clubhouse_horizontal.webp';
import landscapeGreenery from '../../assets/images/CPR_COSMOS/landscapeGreenery.webp';
import desinger_landscape from '../../assets/images/CPR_COSMOS/designer_landscape.webp';




import { faArrowRight, faBuilding, faBolt, faLayerGroup, faExpand, faCompass, faShield, faBasketballBall, faChild, faWalking, faPhoneAlt, faHeartPulse, faHandsPraying, faGlassCheers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PhoneOutlined, WhatsAppOutlined } from '@ant-design/icons';

import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FloatButton, Masonry, Modal } from 'antd';


// Amenities images for wellness section
import banquetHall from '../../assets/images/CPR_COSMOS/amenities/banquet-hall.webp';
import basketballCourt from '../../assets/images/CPR_COSMOS/amenities/basketballCourt.webp';
import tableGames from '../../assets/images/CPR_COSMOS/amenities/board&table-games.webp';
import gym from '../../assets/images/CPR_COSMOS/amenities/gym.webp';
import kidsPlayArea from '../../assets/images/CPR_COSMOS/amenities/kidsPlayArea.webp';
import libraryRoom from '../../assets/images/CPR_COSMOS/amenities/libraryRoom.webp';
import mainElevationEntrance from '../../assets/images/CPR_COSMOS/amenities/mainElevationEntrance.webp';
import swimmingPool from '../../assets/images/CPR_COSMOS/amenities/swimmingPool.webp';
import yogaSpace from '../../assets/images/CPR_COSMOS/amenities/yoga-space.webp';

import banner_spec from '../../assets/images/img_two.webp';

import CPR_Cosmos_Brochure from '../../assets/docs/CPR_Cosmos_Brochure.pdf';
import MetaHelper from '../MetaHelper';


const CosmosPage = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formMode, setFormMode] = useState('manual'); 
    const [autoPopupCount, setAutoPopupCount] = useState(0); 


    const [masonryColumns, setMasonryColumns] = useState(window.innerWidth < 768 ? 2 : 4);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        city: '', // Added City State tracking parameter
        interest: '2 BHK Independent Flat', // Default value
        message: ''
    });
    const [formStatus, setFormStatus] = useState({ type: '', message: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'phone') {
            const onlyNums = value.replace(/[^0-9]/g, ''); // Remove anything not a number
            if (onlyNums.length <= 10) {
                setFormData(prev => ({ ...prev, [name]: onlyNums }));

                // Clear the error message if they are typing a valid-ish sequence
                if (formStatus.message === 'Please enter a valid 10-digit phone number.') {
                    setFormStatus({ type: '', message: '' });
                }
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    // This is for contact section's for at the bottom of the page
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // VALIDATION
        if(formData.phone.length !== 10) {
            setFormStatus({type: 'error', message: 'Please enter a valid 10-digit phone number.'});
            return;
        }

        setFormStatus({ type: 'loading', message: 'Sending inquiry...' });

        try {
            const response = await fetch('cosmos-contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({...formData, source: 'CPR Cosmos - From Contact Form'}),
            });
            
            const result = await response.json();

            if (result.status === 'success') {
                setFormStatus({ type: 'success', message: result.message });
                setFormData({ name: '', email: '', phone: '', city: '', interest: '2 BHK Independent Flat', message: '' });
                navigate('/cpr-cosmos/thank-you', {
                    state: {
                        project: 'CPR Cosmos',
                        returnPath: '/cpr-cosmos'
                    }
                });
            } else {
                setFormStatus({ type: 'error', message: result.message });
            }
        } catch (error) {
            setFormStatus({ type: 'error', message: 'Network error. Please try again later.' });
        }
    };

    // 2. Corrected handleBrochureSubmit (Modal)
    const handleBrochureSubmit = async (e) => {
        e.preventDefault();
        
        // 1. VALIDATION
        if (formData.phone.length !== 10) {
            setFormStatus({ type: 'error', message: 'Please enter a valid 10-digit phone number.' });
            return;
        }
        
        // 2. OPEN YOUTUBE IMMEDIATELY (Bypasses popup blockers)
        window.open('https://www.youtube.com/watch?v=LvOLNoyKxH8', '_blank');

        setFormStatus({ type: 'loading', message: 'Processing your request...' });

        const finalizeRequest = () => {
            setIsModalOpen(false); 
            setFormData({ name: '', email: '', phone: '', city: '', interest: '2 BHK Independent Flat', message: '' });
            
            // 3. TRIGGER PDF DOWNLOAD FOR EVERYONE
            const link = document.createElement('a');
            link.href = CPR_Cosmos_Brochure;
            link.download = 'CPR_Cosmos_Brochure.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // 4. NAVIGATE TO THANK YOU PAGE
            navigate('/cpr-cosmos/thank-you', {
                state: {
                    project: 'CPR Cosmos',
                    returnPath: '/cpr-cosmos'
                }
            })
        };

        try {
            const response = await fetch('cosmos-contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    ...formData, 
                    interest: formMode === 'auto' ? 'Auto-Popup Enquiry' : 'Brochure Download Request', 
                    source: `CPR Cosmos - ${formMode === 'auto' ? 'Auto Popup' : 'Manual Brochure Button'}` 
                }),
            });
            
            const result = await response.json();

            if (result.status === 'success') {
                // --- META PIXEL LEAD TRACKING ---
                if (window.fbq) {
                    window.fbq('track', 'Lead', {
                        content_name: 'CPR Cosmos Inquiry',
                        content_category: 'Landing Page Form',
                        value: 0.00,
                        currency: 'INR'
                    });
                }
                finalizeRequest();
            } else {
                setFormStatus({ type: 'error', message: result.message });
            }
        } catch (error) {
            console.error("Submission error:", error);
            finalizeRequest();
        }
    };

    const handleBrochureClick = (e) => {
        if (e) e.preventDefault();
        setFormMode('manual'); // Force manual text
        setFormData(prev => ({ ...prev, interest: 'Brochure Download Request' }));
        setIsModalOpen(true);
    };

    // --- LINT-SAFE META PIXEL INITIALIZATION & PAGE VIEW RETARGETING ---
    useEffect(() => {
        if (!window.fbq) {
            (function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

            window.fbq('init', '2170946923705541');
        }

        window.fbq('track', 'PageView');
        window.fbq('track', 'ViewContent', { 
            content_name: 'CPR Cosmos Landing Page',
            content_category: 'Real Estate Project' 
        });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setMasonryColumns(window.innerWidth < 768 ? 2 : 4);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    useEffect(() => {
        let timer;
        // Trigger if modal is closed and hasn't appeared more than 3 times
        if (!isModalOpen && autoPopupCount < 3) {
            // First wait: 8 seconds | Subsequent waits: 40 seconds
            const delay = autoPopupCount === 0 ? 8000 : 40000;

            timer = setTimeout(() => {
                setFormMode('auto'); 
                setIsModalOpen(true);
                setAutoPopupCount(prev => prev + 1);
            }, delay);
        }
        return () => clearTimeout(timer);
    }, [isModalOpen, autoPopupCount]);

    const facts = [
        { icon: faExpand, title: "16,000 Sq. Yds.", desc: "Expansive Gated Community Land" },
        { icon: faBuilding, title: "288 Units", desc: "Premium 2 & 3 BHK Apartments" },
        { icon: faLayerGroup, title: "C + G + 8 Floors", desc: "Modern High-Rise Structure" },
        { icon: faCompass, title: "100% Vastu", desc: "Built for Spiritual Harmony" },
        { icon: faShield, title: "No Common Walls", desc: "Total Independence & Ventilation" },
        { icon: faBolt, title: "Power Backup", desc: "Common Areas & Key Points in Every Flat" }
    ];
    
    const [envState, setEnvState] = useState('default'); // 'default', 'east', 'west'


    // ----------------------------------
    // Wellness and clubhouse part
    // ----------------------------------
    const wellnessMasonryImages = [
    {
        title: 'Grand Entrance & Lounge', 
        img: mainElevationEntrance, // Page 3
    },
    {
        title: 'Luxury Swimming Pool',
        img: swimmingPool, // Page 6
    },
    {
        title: 'High-Tech Gymnasium', 
        img: gym, // Page 11
    },
    {
        title: 'Cricket Practice Pitch',
        img: basketballCourt, // Refers to outdoor sports on Page 11
    },
    {
        title: 'Multipurpose Banquet Hall', 
        img: banquetHall, // Page 11
    },
    {
        title: 'Indoor Games & Billiards',
        img: tableGames, // Page 11
    },
    {
        title: 'Designer Landscape Garden',
        img: desinger_landscape, // Page 11
    },
    {
        title: 'Meditation & Yoga Hall',
        img: yogaSpace, // Page 11
    },
    {
        title: 'Children’s Play Area',
        img: kidsPlayArea, // Page 11
    },
    {
        title: 'Coffee Shop & Lounge',
        img: libraryRoom, // Specifically mentioned as a premium perk
    }
];

    // ----------------------------------
    // Care Pillars Section - Updated for CPR Cosmos
    // ----------------------------------
    const carePillars = [
        {
            icon: faHandsPraying,
            tag: "SPIRIT",
            title: "Mindful Serenity",
            items: [
                "Yoga & Meditation Hall",
                "Designer Landscape Gardens",
                "Elder Seating Zones",
                "Vastu-Compliant Architecture"
            ]
        },
        {
            icon: faHeartPulse,
            tag: "HEALTH",
            title: "Active Wellness",
            items: [
                "High-Tech Gymnasium",
                "Swimming Pool & Kids Pool",
                "Jogging & Walking Track",
                "Outdoor Sports Courts"
            ]
        },
        {
            icon: faGlassCheers,
            tag: "LEISURE",
            title: "Social Recreation",
            items: [
                "Grand Double-Height Lounge",
                "Multipurpose Banquet Hall",
                "Indoor Games & Billiards",
                "Rooftop Coffee Shop"
            ]
        }
    ];

    // ----------------------------------
    // Location Section - Updated for Tirupati
    // ----------------------------------
    const locations = [
        { 
            name: "Renigunta Road", 
            time: "01", 
            desc: "Direct Access", 
            pos: "north" 
        },
        { 
            name: "Tirupati Airport", 
            time: "15", 
            desc: "International Hub", 
            pos: "east" 
        },
        { 
            name: "Tirupati Rly Station", 
            time: "08", 
            desc: "Main City Terminal", 
            pos: "south" 
        },
        { 
            name: "Ankura Hospital", 
            time: "<01", 
            desc: "Premium Healthcare", 
            pos: "west" 
        }
    ];


    return(
        <Container fluid className="cosmosPage p-0">
            <MetaHelper 
                title="CPR Cosmos | Luxury Gated Community Renigunta Road" 
                description="Explore CPR Cosmos on Renigunta Road, Tirupati. Premium 2 & 3 BHK independent apartments with zero common walls and world-class amenities."
            />
            <Row id='hero' className='hero-video-section mb-2 g-0'>
                {/* Using an image since no video is available; object-fit: cover maintains the hero look */}
                <img 
                    src={bannerImg} // Replace with your path to the brochure's main building render
                    alt="CPR Cosmos Exterior"
                    className="video hero-img" // Kept class name 'video' to inherit existing styles
                    style={{width: '100%', height: '100vh', objectFit: 'cover'}}
                     
                />
                <div className='hero-overlay'>
                    <div className='hero-overlay-content text-center text-lg-end'>
                        <div className='left-side'>
                            <a href='#contact-row'><img src={banner_spec} className='banner-spec-img' /></a>
                        </div>
                        <div className='right-side'>
                            <h3>Consistent Property Returns</h3>
                            <h1>CPR Cosmos</h1>
                            <h6>
                                Premium 2 & 3 BHK | 288 Units | 15,000 Sq.ft. Clubhouse
                            </h6>                        
                            <div className="hero-btn-wrapper mt-4 d-flex justify-content-center justify-content-lg-end">
                                <Button 
                                    variant="light" 
                                    className="download-brochure-btn px-4 py-2 rounded-pill fw-bold shadow-sm"
                                    onClick={handleBrochureClick}
                                >
                                    DOWNLOAD BROCHURE 
                                    <FontAwesomeIcon icon={faArrowRight} className="ms-2 arrow-icon" />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Row>

            <Row id='overview' className="narrative-row g-0 align-items-center bg-white">
                {/* Left Side: Content Column */}
                <Col lg={6} className="narrative-content-col p-5 p-lg-10">
                    <div className="content-wrapper px-md-5">
                        <h6 className="section-subtitle mb-3">THE WORLD OF HAPPINESS</h6>
                        <h2 className="section-title mb-4">Classy People’s Residences</h2>
                        
                        <p className="narrative-paragraph">
                            Tirupati is stepping into a new era with <strong>CPR Constructions</strong> 
                            <br />15yrs | 25 Projects | trusted by 2000 Families, <strong>COSMOS</strong> upscale gated community of <strong>premium apartments</strong> on the high appreciation stretch of Renigunta Road. 
                            Rising gracefully on beautifully planned 60ft wide road, this landmark project 
                            offers a secure, stylish, and peaceful lifestyle enriched with Best amenities. 
                            Every apartment is designed as a 
                            Total Independent Home with "No share" walls, ensuring 360‑degree ventilation, abundant natural light, and complete privacy. 
                            CPR Cosmos isn’t just a home — it’s <strong>a luxury lifestyle</strong> upgrade that reflects your success, comfort, and modern aspirations.
                        </p>
                    </div>
                </Col>

                {/* Right Side: Image Carousel Column */}
                <Col lg={6} className="narrative-carousel-col">
                    <Carousel fade indicators={true} controls={false} interval={4000} className="h-100">
                        <Carousel.Item className="h-100">
                            <div className="narrative-img-frame">
                                <Image 
                                    src={bannerImg} 
                                    className="w-100 h-100 object-fit-cover" 
                                    alt="CPR Cosmos Architecture" 
                                    style={{objectPosition: 'center 20%'}}
                                />
                            </div>
                        </Carousel.Item>
                        <Carousel.Item className="h-100">
                            <div className="narrative-img-frame">
                                <Image 
                                    src={clubhouseImg} 
                                    className="w-100 h-100 object-fit-cover" 
                                    alt="Luxury Clubhouse and Pool" 
                                />
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </Col>
            </Row>
            
            {/* Quick Facts Row */}
            <Row className="quick-facts-row g-0 py-5 bg-light justify-content-center">
                <Col md={10} className="py-5">
                    <div className="text-center mb-5">
                        <h6 className="section-subtitle">PROJECT AT A GLANCE</h6>
                        <h2 className="fw-bold">Defining Modern Living in Tirupati</h2>
                    </div>
                    <Row className="g-4">
                        {facts.map((fact, index) => (
                            <Col md={4} key={index} className="d-flex align-items-start p-4 fact-card">
                                <div className="fact-icon-box me-3">
                                    <FontAwesomeIcon icon={fact.icon} />
                                </div>
                                <div>
                                    <h5 className="fw-bold mb-1" style={{fontSize: '1.1rem'}}>{fact.title}</h5>
                                    <p className="text-muted mb-0 small">{fact.desc}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>

            {/* SECTION 4: THE ARCHITECTURE OF PRIVACY (INDEPENDENT HOMES LOGIC) */}
            <Row id='architecture' className="env-compass-section g-0 py-5 bg-white overflow-hidden">
                <Col lg={12} className="text-center mb-5">
                    <h6 className="section-subtitle">ARCHITECTURAL EXCELLENCE</h6>
                    <h2 className="section-title">Fresh Air & Personal Space Meter</h2>
                    <p className="text-muted">Explore how our "Planet of Sophistication" uses independent blocks to capture nature's best elements.</p>
                </Col>

                <Container>
                    <Row className="align-items-center">
                        {/* Interactive UI Controls */}
                        <Col lg={3} className="order-2 order-lg-1">
                            <div 
                                className={`env-card ${envState === 'east' ? 'active' : ''}`}
                                onMouseEnter={() => setEnvState('east')}
                                onMouseLeave={() => setEnvState('default')}
                            >
                                <h5>East Facing</h5>
                                <p>Specifically designed for Vastu-compliant sunrises. These units range from 1669 to 2083 SFT, welcoming the morning light into spacious 3BHK living areas.</p>
                                <span className="stat-tag">100% Vastu</span>
                            </div>

                            <div 
                                className={`env-card mt-4 ${envState === 'west' ? 'active' : ''}`}
                                onMouseEnter={() => setEnvState('west')}
                                onMouseLeave={() => setEnvState('default')}
                            >
                                <h5>West Facing</h5>
                                <p>Capture the cool, natural breeze. This wing includes a mix of expansive 2083 Sq.ft. 3BHKs and compact, efficient 1230 Sq.ft. 2BHKs, all benefiting from the open-sky ventilation.</p>
                                <span className="stat-tag">Airy & Efficient</span>
                            </div>
                        </Col>

                        {/* The Visual Floor Plan Area */}
                        <Col lg={6} className="order-1 order-lg-2 position-relative d-flex justify-content-center">
                            <div className="floor-plan-wrapper">
                                {/* Replace floorPlanImg with the Typical Floor Plan from Brochure Page 11 */}
                                <Image   src={floorPlanImg} alt="CPR Cosmos Typical Floor Plan" className="main-floor-plan" />

                                <AnimatePresence>
                                    {envState === 'east' && (
                                        <motion.div 
                                            initial={{ opacity: 0, x: -50 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            exit={{ opacity: 0 }}
                                            className="sunlight-glow east"
                                        />
                                    )}
                                    {envState === 'west' && (
                                        <motion.div 
                                            initial={{ opacity: 0, x: 50 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            exit={{ opacity: 0 }}
                                            className="sunlight-glow west"
                                        />
                                    )}
                                </AnimatePresence>

                                {/* Wind Lines pulse to show 3-side ventilation */}
                                <div className={`wind-container ${envState !== 'default' ? 'active' : ''}`}>
                                    <div className="wind-line line-1"></div>
                                    <div className="wind-line line-2"></div>
                                    <div className="wind-line line-3"></div>
                                </div>
                            </div>
                        </Col>

                        {/* Technical Details - Adapted for CPR Constructions' Quality Standards */}
                        <Col lg={3} className="order-3 p-4">
                            <div className="tech-spec-box">
                                <h4 className="fw-bold text-primary-blue">NO</h4>
                                <p className="small text-uppercase fw-bold mb-1">Shared Walls</p>
                                <p className="text-muted extra-small">In our "New Universe," every apartment is a standalone island. Zero shared walls mean zero acoustic interference and total freedom for your family.</p>
                            </div>
                            <div className="tech-spec-box mt-4">
                                <h4 className="fw-bold text-primary-blue">10-FOOT</h4>
                                <p className="small text-uppercase fw-bold mb-1">Breathing Corridors</p>
                                <p className="text-muted extra-small">With 10-foot setbacks between flats and 30-foot setbacks around the blocks, we ensure a constant flow of fresh air and 3-side natural lighting for every home.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>
            
            {/* --- SECTION 5: THE ARCHITECTURAL EDGE (Merged Privacy & Ventilation) --- */}
            <Row className="interior-showcase-row align-items-center bg-white px-3 px-lg-10 py-5">
                <Col lg={6} className="order-2 order-lg-1 pe-lg-5 py-4">
                    <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
                        <h6 className="section-subtitle mb-3">ARCHITECTURAL EXCLUSIVITY</h6>
                        <h2 className="section-title mb-4">Total Independent Homes for Total Peace of Mind</h2>
                        <p className="narrative-paragraph">
                            Experience the luxury of an independent house within a secure, master‑planned gated community. 
                            At <strong>CPR Cosmos</strong>, every block is thoughtfully spaced to ensure 
                            <strong> zero shared walls</strong> between units. This unique architectural choice 
                            guarantees total acoustic privacy and enables <strong>3-side open ventilation</strong> 
                            for every home, allowing your living space to breathe naturally.
                            This is architecture that lets your home breathe naturally — and lets your family live with happiness.
                        </p>
                    </motion.div>
                </Col>
                <Col lg={6} className="order-1 order-lg-2 py-4">
                    <div className="interior-image-card shadow-lg">
                        <Image   src={allBlocksImg} className="w-100 h-100 object-fit-cover" alt="CPR Cosmos Independent Design" />
                    </div>
                </Col>
            </Row>

            {/* --- SECTION 6: THE VERDANT UNIVERSE (Greenery Section) --- */}
            <Row id='greenery' className="interior-showcase-row align-items-center bg-light px-3 px-lg-10 py-5">
                <Col lg={6} className="py-4">
                    <div className="interior-image-card shadow-lg">
                        <Image   src={landscapeGreenery} className="w-100 h-100 object-fit-cover" alt="CPR Cosmos Lush Greenery" />
                    </div>
                </Col>
                <Col lg={6} className="ps-lg-5 py-4">
                    <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
                        <h6 className="section-subtitle mb-3">NATURAL HARMONY</h6>
                        <h2 className="section-title mb-4">A Planet of Greenery & Serenity</h2>
                        <p className="narrative-paragraph">
                            Life at <strong>CPR Cosmos</strong> is painted in shades of emerald. Surrounded by 
                            lush landscapes and meticulously planned open spaces, our community offers a 
                            peaceful retreat from the urban bustle. Whether it's a morning stroll through 
                            the designer gardens or quiet reflection in the elder seating zones, nature is 
                            your constant companion in this world of happiness.
                        </p>
                    </motion.div>
                </Col>
            </Row>

            {/* Clubhouse masonry */}
            <Row id='clubhouse' className='wellness-masonry-grid p-5 bg-white'>
                <Col lg={12} className="text-center mb-5">
                    <motion.h6 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="section-subtitle mb-3"
                    >
                        15,000 SQ.FT. LUXURY CLUBHOUSE
                    </motion.h6>

                    <motion.h2 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="display-5 fw-bold text-primary-blue"
                    >
                        A Universe of Leisure
                    </motion.h2>
                    
                    <motion.p 
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.4 }}
                        className="text-muted mx-auto mt-3" 
                        style={{ maxWidth: '600px' }}
                    >
                        Explore a dedicated 5-level destination designed for wellness and elite living. 
                        From a grand reception to a rooftop café, every detail is crafted for your recreation.
                    </motion.p>
                </Col>
                <Masonry
                    columns={masonryColumns}
                    gutter={16}
                    items={wellnessMasonryImages.map((item, index) => ({
                        key: `item-${index}`,
                        data: item,
                    }))}
                    itemRender={({ data }) => (
                        <div className="wellness-masonry-item">
                            <img 
                                src={`${data.img}?w=523&auto=format`} 
                                alt={data.title} 
                                className="wellness-img" 
                                 
                            />
                            <div className="wellness-overlay">
                                <div className="wellness-overlay-content">
                                    <h4>{data.title}</h4>
                                </div>
                            </div>
                        </div>
                    )}
                />
                <div className='text-end mt-3'><strong>**All images are for illustrative purposes only</strong></div>
            </Row>

            {/* FEATURED AMENITY SPOTLIGHT: The 5-Level Clubhouse */}
            <Row className="wellness-spotlight-row g-0 bg-white p-5">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={7} className="mb-4 mb-lg-0">
                            <div className="spotlight-image-container">
                                <Image 
                                    src={clubhouseImg} // Using the visual from Page 6 (Pool & Facade)
                                    className="img-fluid rounded-4 shadow-sm" 
                                    alt="CPR Cosmos Luxury Clubhouse" 
                                />
                            </div>
                        </Col>
                        <Col lg={5} className="ps-lg-5">
                            <motion.div
                                initial={{ opacity: 0, x: 20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <h6 className="section-subtitle mb-2">EXCLUSIVE ACCESS</h6>
                                <h2 className="fw-bold mb-4">5 Levels of Leisure</h2>
                                <p className="text-muted mb-4">
                                    The heart of our community is a massive <strong>15,000 Sq. Ft. Clubhouse</strong>. 
                                    From the grand double-height lounge to the rooftop café, every floor 
                                    is designed to provide a perfect balance of elite indoor and outdoor living.
                                </p>
                                <div className="d-flex gap-3">
                                    <div className="mini-stat">
                                        <h4 className="mb-0 fw-bold">15K</h4>
                                        <small className="text-muted">Square Feet</small>
                                    </div>
                                    <div className="mini-stat">
                                        <h4 className="mb-0 fw-bold">5</h4>
                                        <small className="text-muted">Leisure Levels</small>
                                    </div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </Row>
            
            {/* THE GREEN ACRES: The Community Landscape */}
            <Row className="env-deck-showcase g-0 p-5 bg-light">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={5} className="order-2 order-lg-1">
                            <motion.div
                                initial={{ opacity: 0, x: -30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <h6 className="section-subtitle mb-3">OUTDOOR SERENITY</h6>
                                <h2 className="section-title mb-4">A Planet of Verdant Surroundings</h2>
                                <p className="narrative-paragraph">
                                    Spanning <strong>16,000 Sq. Yds.</strong>, CPR Cosmos is engineered for 
                                    maximum breathing room. With 30ft wide setbacks and designer gardens, we've 
                                    created a sanctuary where nature is your constant companion.
                                </p>
                                <ul className="deck-features-list list-unstyled mt-4">
                                    <li className="mb-2"><FontAwesomeIcon icon={faBasketballBall} className="text-primary me-2"/> Cricket Practice Pitch & Tennis Court</li>
                                    <li className="mb-2"><FontAwesomeIcon icon={faChild} className="text-success me-2"/> Children’s Play Area & Party Lawn</li>
                                    <li><FontAwesomeIcon icon={faWalking} className="text-info me-2"/> Jogging Track & Elder Seating Zones</li>
                                </ul>
                            </motion.div>
                        </Col>
                        
                        <Col lg={7} className="order-1 order-lg-2 mb-4 mb-lg-0">
                            <div className="deck-visual-wrapper">
                                <Image 
                                    src={desinger_landscape} // Use the Master Plan or Landscape render from Page 14
                                    className="img-fluid rounded-4 shadow-lg" 
                                    alt="CPR Cosmos Landscape" 
                                />
                                <div className="deck-stat-overlay">
                                    <div className="stat-item">
                                        <span>Open Space</span>
                                        <strong>30+ FT</strong>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* Care Pillars Section  */}
            <Row className="care-pillars-section g-4">
                <Container>
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={12}>
                            <motion.h6 
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                className="section-subtitle text-cyan mb-2"
                            >
                                A BLESLED LIFESTYLE
                            </motion.h6>
                            <motion.h2 
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                className="fw-bold text-white display-5"
                            >
                                Spirit, Health & Leisure
                            </motion.h2>
                            <motion.p className="text-white-50 mt-3 mx-auto" style={{ maxWidth: '600px' }}>
                                Experience a holistic life at <strong>CPR Cosmos</strong>, where thoughtfully 
                                designed spaces nurture your well-being in a secure, upscale gated community.
                            </motion.p>
                        </Col>
                    </Row>
                    

                    <Row className='gy-4'>
                        {carePillars.map((pillar, idx) => (
                            <Col lg={4} key={idx}>
                                <motion.div 
                                    className="pillar-card"
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6, delay: idx * 0.2 }}
                                    viewport={{ once: true }}
                                >
                                    <div className="pillar-header">
                                        <div className="pillar-icon-box">
                                            <FontAwesomeIcon icon={pillar.icon} />
                                        </div>
                                        <span className="pillar-tag">{pillar.tag}</span>
                                    </div>
                                    
                                    <h4 className="pillar-title">{pillar.title}</h4>
                                    
                                    <ul className="pillar-list">
                                        {pillar.items.map((feature, fIdx) => (
                                            <li key={fIdx}>{feature}</li>
                                        ))}
                                    </ul>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </Row>



            {/* TECHNICAL CRAFTSMANSHIP (Ref: Page 12) */}
            <Row id="specifications" className="specs-row py-5 bg-white mx-0">
                <Container>
                    <Row className="text-center mb-5">
                        <Col lg={12}>
                            <h6 className="section-subtitle">THE BLUEPRINT OF QUALITY</h6>
                            <h2 className="section-title">Technical Specifications</h2>
                            <p className="text-muted mx-auto" style={{ maxWidth: '600px' }}>
                                Every corner of CPR Cosmos is built with precision-engineered materials 
                                and premium finishes to ensure lasting luxury.
                            </p>
                        </Col>
                    </Row>
                    
                    <Row className="g-4 align-items-center">
                        {/* Left Side: Image representing the finished quality */}
                        <Col lg={5}>
                            <div className="spec-image-wrapper shadow-lg rounded-4 overflow-hidden">
                                {/* USE: The Living Room render from Page 4 or Bedroom from Page 7 */}
                                <Image 
                                    src={clubhouseImg} 
                                    className="img-fluid w-100 h-100 object-fit-cover" 
                                    alt="CPR Cosmos Interior Quality" 
                                    style={{ minHeight: '400px' }}
                                />
                            </div>
                        </Col>

                        {/* Right Side: The Technical Details Grid */}
                        <Col lg={7} className="ps-lg-5">
                            <Row className="g-4">
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Structure</h5>
                                        <p className="small text-muted mb-0">R.C.C. Framed Structure designed to resist wind and seismic loads.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Flooring</h5>
                                        <p className="small text-muted mb-0">Premium 800x800mm Double Charged Vitrified Tiles in all major rooms.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Joinery</h5>
                                        <p className="small text-muted mb-0">Teak wood main door frame with melamine polish and reputed hardware.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Electrical</h5>
                                        <p className="small text-muted mb-0">Concealed copper wiring with modular switches from Legrand/Anchor.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Kitchen</h5>
                                        <p className="small text-muted mb-0">Granite platform with stainless steel sink and power points for modern appliances.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Plumbing</h5>
                                        <p className="small text-muted mb-0">PVC/CPVC piping with premium sanitary ware from Hindware/Parryware.</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Row>



            {/* Connectivity Section */}
            <Row id='location' className="connectivity-section p-5 bg-white overflow-hidden">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={5}>
                            <motion.h6 
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                className="section-subtitle"
                            >
                                STRATEGIC LOCATION
                            </motion.h6>
                            
                            <h2 className="display-5 fw-bold text-primary-blue">The Star Address</h2>
                            
                            <p className="lead text-muted mt-4">
                                Ideally positioned at <strong>Postal Colony (19th Ward)</strong>, CPR Cosmos 
                                offers premium connectivity via a dedicated <strong>60-foot BT Road</strong>. 
                                Enjoy effortless access to Renigunta Road’s vibrant commercial hubs, 
                                top-tier hospitals, and major transit gateways.
                            </p>

                            <div className="investment-badge mt-4 p-4 border-start border-4 border-info bg-light rounded-end">
                                <h5 className="fw-bold mb-1">Developer Legacy</h5>
                                <p className="text-muted small mb-2">CPR Constructions - ISO 9001:2015 Certified</p>
                                <div className="d-flex align-items-center gap-2">
                                    <h3 className="fw-extrabold text-primary-blue mb-0">16+</h3>
                                    <small className="text-uppercase tracking-wider fw-bold">Years of Excellence</small>
                                </div>
                            </div>
                        </Col>

                        <Col lg={7} className="radar-viewport">
                            <div className="radar-system">
                                {/* The Central Hub */}
                                <div className="credence-hub">
                                    <div className="radar-ping"></div>
                                    <div className="radar-ping secondary"></div>
                                    <div className="hub-logo-container">
                                        <Image   src={logo} alt="CPR Cosmos" style={{ width: '120px' }} />
                                    </div>
                                </div>

                                {/* The Compass Nodes */}
                                {locations.map((loc, index) => (
                                    <motion.div 
                                        key={index}
                                        className={`radar-node ${loc.pos}`}
                                        initial={{ opacity: 0, scale: 0 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: index * 0.15, duration: 0.5 }}
                                    >
                                        <div className="node-capsule">
                                            <div className="node-time-hub">{loc.time}m</div>
                                            <div className="node-details">
                                                <h6>{loc.name}</h6>
                                                <p>{loc.desc}</p>
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* SECTION 11: CONTACT US */}
            <Row id="contact" className="contact-section g-0 py-5 bg-white">
                <Container className="py-5">
                    <Row className="gy-5 align-items-center">
                        {/* Left Side: Info */}
                        <Col lg={5}>
                            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
                                <h6 className="section-subtitle">GET IN TOUCH</h6>
                                <h2 className="section-title mb-4 text-primary-blue" id='contact-row'>Visit Your Star Address</h2>
                                <p className="narrative-paragraph mb-5">
                                    Experience a "Planet of Rare Sophistication" for yourself. Our sales gallery is open daily 
                                    to guide you through our 15,000 Sq.ft. clubhouse and premium 2 & 3 BHK apartment layouts.
                                </p>

                                <div className="contact-detail-item d-flex mb-4">
                                    <div className="icon-box me-3 text-primary">
                                        <FontAwesomeIcon icon={faPhoneAlt} /> 
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Call for Enquiries</h6>
                                        <div className="d-flex flex-column">
                                            <div className='contact-number'>
                                                <div>Abhinav. K:</div>
                                                <a href="tel:+919908788633" className="text-decoration-none text-dark fw-bold mb-1">
                                                    +91 99087 88633
                                                </a>
                                            </div>
                                            <div className='contact-number'>
                                                <div>Bharathi.V:</div>
                                                <a href="tel:+917330851777" className="text-decoration-none text-dark fw-bold mb-1">
                                                    +91 73308 51777
                                                </a>
                                            </div>
                                            <div className='contact-number'>
                                                <div>Kasi.V:</div>
                                                <a href="tel:+919492040502" className="text-decoration-none text-dark fw-bold mb-1">
                                                    +91 94920 40502
                                                </a>
                                            </div>
                                        </div>
                                        <p className="text-muted small mt-1 mb-0">Sales & Site Visit Queries</p>
                                    </div>
                                </div>

                                <div className="contact-detail-item d-flex mb-4">
                                    <div className="icon-box me-3 text-primary"><FontAwesomeIcon icon={faCompass} /></div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Site Address</h6>
                                        <p className="text-muted small">CPR Cosmos, Ward No. 19, Postal Colony, Renigunta Road, Tirupati - 517501.</p>
                                    </div>
                                </div>

                                <div className="contact-detail-item d-flex mb-4">
                                    <div className="icon-box me-3 text-primary"><FontAwesomeIcon icon={faBuilding} /></div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Corporate Office</h6>
                                        <p className="text-muted small">CPR Constructions, Renigunta Rd, beside Ankura Hospital, Korramenugunta, Tirupati, AP 517501.</p>
                                    </div>
                                </div>
                            </motion.div>
                        </Col>

                        {/* Right Side: Functional Form */}
                        <Col lg={{ span: 6, offset: 1 }}>
                            <motion.div className="contact-form-card p-4 p-md-5 shadow-lg rounded-4" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}>
                                <h4 className="fw-bold mb-4">Request a Call Back</h4>
                                <form onSubmit={handleFormSubmit}>
                                    <Row className="g-3">
                                        <Col md={12}>
                                            <input name="name" type="text" className="form-control custom-input" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
                                        </Col>
                                        <Col md={6}>
                                            <input name="email" type="email" className="form-control custom-input" placeholder="Email Address" value={formData.email} onChange={handleInputChange} required />
                                        </Col>
                                        <Col md={6}>
                                            <input 
                                                name="phone" 
                                                type="tel" 
                                                className="form-control custom-input" 
                                                placeholder="Phone Number" 
                                                value={formData.phone}  
                                                onChange={handleInputChange} 
                                                required 
                                                pattern='[0-9]{10}' 
                                                inputMode='numeric' 
                                            />
                                            {/* INLINE ERROR TEXT */}
                                            {formData.phone.length > 0 && formData.phone.length < 10 && (
                                                <small className="text-danger" style={{ fontSize: '10px', display: 'block', marginTop: '2px' }}>
                                                    Must be 10 digits
                                                </small>
                                            )}
                                        </Col>
                                        {/* Added City Field to inline Contact Section layout context */}
                                        <Col md={12}>
                                            <input name="city" type="text" className="form-control custom-input" placeholder="City" value={formData.city} onChange={handleInputChange} required />
                                        </Col>
                                        <Col md={12}>
                                            <select name="interest" className="form-select custom-input" value={formData.interest} onChange={handleInputChange}>
                                                <option value="2 BHK Apartment">2 BHK Apartment</option>
                                                <option value="3 BHK Apartment">3 BHK Apartment</option>
                                                <option value="Site Visit Request">Schedule a Site Visit</option>
                                                <option value="Brochure Request">Download Digital Brochure</option>
                                            </select>
                                        </Col>
                                        <Col md={12}>
                                            <textarea name="message" className="form-control custom-input" rows="4" placeholder="How can we help you?" value={formData.message} onChange={handleInputChange}></textarea>
                                        </Col>
                                        <Col md={12}>
                                            <Button type="submit" disabled={formStatus.type === 'loading'} className="w-100 py-3 mt-2 fw-bold bg-primary-blue border-0 rounded-3 text-white">
                                                {formStatus.type === 'loading' ? 'SENDING...' : 'BOOK A SITE VISIT'}
                                            </Button>
                                            {formStatus.message && (
                                                <div className={`mt-3 small text-center ${formStatus.type === 'error' ? 'text-danger' : 'text-success'}`}>
                                                    {formStatus.message}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </form>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* FOOTER SECTION */}
            <footer className="bg-dark text-white py-5">
                <Container>
                    <Row className="align-items-center gy-4">
                        <Col lg={4} className="text-center text-lg-start">
                            <Image   src={logo} alt="CPR Cosmos" style={{ width: '120px',}} />
                            <p className="mt-3 text-white-50 small">
                                A premium gated community project by CPR Constructions, 
                    offering classy people’s residences in Tirupati.
                            </p>
                        </Col>
                        <Col lg={4} className="text-center">
                            <h6 className="fw-bold mb-3">Quick Links</h6>
                            <div className="d-flex justify-content-center gap-3">
                                <a href="#overview" className="text-white-50 text-decoration-none small">Overview</a>
                                <a href="#architecture" className="text-white-50 text-decoration-none small">Architecture</a>
                                <a href="#clubhouse" className="text-white-50 text-decoration-none small">Clubhouse</a>
                                <a href="#location" className="text-white-50 text-decoration-none small">Location</a>
                                {/* Use Link for the Privacy Policy route */}
                                <Link to="/privacy-policy" className="text-white-50 text-decoration-none small">
                                    Privacy Policy
                                </Link>
                            </div>
                        </Col>
                        <Col lg={4} className="text-center text-lg-end">
                            <p className="mb-0 small text-white-50">© 2026 CPR Constructions. All Rights Reserved.</p>
                            <p className="small text-white-50">RERA Certified Project</p>
                            {/* Your Brand Credit Added Here */}
                            <p className="mb-0 small" style={{ color: '#888' }}>
                                Designed by <a 
                                    href="https://bixianperformancemarketing.com"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ color: '#00d1ff', textDecoration: 'none', fontWeight: '500' }}
                                >
                                    Bixian Performance Marketing
                                </a>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>

            <Modal
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                centered
                destroyOnClose={true}
                className="brochure-modal"
            >
                <div className="p-3">
                    <div className="text-center mb-4">
                        <h3 className="fw-bold text-primary-blue">
                            {formMode === 'manual' ? "Get the Full Brochure" : "View Current Site Progress?"}
                        </h3>
                        {/* CONDITIONAL SUBTITLE */}
                        <p className="text-muted">
                            {formMode === 'manual' 
                                ? "Enter your details to unlock the project specifications and floor plans." 
                                : "Leave your details below and our team will reach out to help you find your dream home."
                            }
                        </p>
                    </div>
                    
                    {/* Fixed onSubmit handler */}
                    <form onSubmit={handleBrochureSubmit}>
                        <div className="mb-3">
                            <input name="name" type="text" className="form-control custom-input" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
                        </div>
                        <Row className="g-2 mb-3">
                            <Col md={6}>
                                <input name="email" type="email" className="form-control custom-input" placeholder="Email Address" value={formData.email} onChange={handleInputChange} required />
                            </Col>
                            <Col md={6}>
                                <input 
                                    name="phone" 
                                    type="tel" 
                                    className="form-control custom-input" 
                                    placeholder="Phone Number" 
                                    value={formData.phone}  
                                    onChange={handleInputChange} 
                                    required 
                                    pattern='[0-9]{10}' 
                                    inputMode='numeric' 
                                />
                                {/* INLINE ERROR TEXT */}
                                {formData.phone.length > 0 && formData.phone.length < 10 && (
                                    <small className="text-danger" style={{ fontSize: '10px', display: 'block', marginTop: '2px' }}>
                                        Must be 10 digits
                                    </small>
                                )}
                            </Col>
                        </Row>
                        {/* Added City Field input block directly within the pop-up Modal architecture */}
                        <div className="mb-3">
                            <input name="city" type="text" className="form-control custom-input" placeholder="City" value={formData.city} onChange={handleInputChange} required />
                        </div>
                        <div className="mb-3">
                            <textarea name="message" className="form-control custom-input" rows="3" placeholder="Any specific requirements? (Optional)" value={formData.message} onChange={handleInputChange}></textarea>
                        </div>
                        <Button 
                            type="submit" 
                            disabled={formStatus.type === 'loading'} 
                            className="w-100 py-3 bg-primary-blue border-0 rounded-pill fw-bold shadow text-white"
                        >
                            {formStatus.type === 'loading' 
                                ? 'PROCESSING...' 
                                : (formMode === 'manual' ? 'SUBMIT & DOWNLOAD' : 'View Current Site Progress')
                            }
                        </Button>
                    </form>
                </div>
            </Modal>


            {/* FLOATING ACTION BUTTONS */}
            <FloatButton.Group
                trigger="hover"
                type="primary"
                style={{ insetInlineEnd: 24, bottom: 24 }}
                icon={<FontAwesomeIcon icon={faCompass} />} // Using your project's theme icon
            >

                {/* Call Button */}
                <FloatButton 
                    icon={<PhoneOutlined />} 
                    href="tel:+919492013322"
                    tooltip={<div>Call Sales Team</div>}
                />


                {/* WhatsApp Button - Using official brand color */}
                <FloatButton 
                    icon={<WhatsAppOutlined />} 
                    target="_blank"
                    href="https://wa.me/+919849643621" // Replace with actual WhatsApp number
                    tooltip={<div>WhatsApp Us</div>}
                    style={{ backgroundColor: '#25D366', color: '#fff' }} 
                />

                {/* Back to Top - Specialized button that handles scrolling automatically */}
                <FloatButton.BackTop 
                    tooltip={<div>Scroll to Top</div>} 
                />
            </FloatButton.Group>
            
            {/* Meta Pixel Noscript Fallback */}
            <noscript>
                <img 
                    height="1" 
                    width="1" 
                    style={{ display: 'none' }}
                    src="https://www.facebook.com/tr?id=2170946923705541&ev=PageView&noscript=1"
                    alt=""
                />
            </noscript>
        </Container>
    )
};

export default CosmosPage;